// extracted by mini-css-extract-plugin
export default {"mainContainer":"Interior_mainContainer__Ptene","interiorContainer":"Interior_interiorContainer__VDUNV","textContainer":"Interior_textContainer__TW5wh"};